import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Icon from '../../components/Icon/Icon';

import './ShareOption.scss';

function ShareOption(props) {
  return (
    <button className='ShareOption' onClick={props.onClick} data-qa={props.qaTag}>
      {props.helperTextObj ? (
        <span className='visuallyHidden'>
          <FormattedMessage {...props.helperTextObj} />
        </span>
      ) : null}
      <Icon className='ShareOption__icon' glyph={props.icon} />
      <FormattedMessage {...props.displayTextObj} />
    </button>
  );
}

ShareOption.propTypes = {
  onClick: PropTypes.func.isRequired,
  displayTextObj: PropTypes.object.isRequired,
  icon: PropTypes.func.isRequired,
  helperTextObj: PropTypes.object,
  qaTag: PropTypes.string,
};

export default ShareOption;
